import React from "react";

function CreateTicket() {
  return (
    <div className="container">
      <div className="row p-5 mt-2 mb-2">
        <h2 className="text-muted" style={{ fontSize: "20px" }}>
          To create a ticket, select a relevant topic{" "}
        </h2>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className="text-muted" style={{ fontSize: "18px" }}>
          <i class="fa-solid fa-circle-plus"></i> Account Opening
          </h4>
          <a href="" style={{ fontSize:"14px", textDecoration: "none", lineHeight: "2.5" }}>
            Resident individual
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Minor
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Non Resident Indian (NRI)
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Company, Partnership, HUF and LLP
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Glossary
          </a>
        </div>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className=" text-muted" style={{ fontSize: "18px" }}>
            <i class="fa-solid fa-user"></i> Your Zerodha Account
          </h4>
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Your Profile
          </a>
          <br />
          <a href="" style={{fontSize:"14px", textDecoration: "none", lineHeight: "2.5" }}>
            Account modification
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Client Master Report (CMR) and Depository Participant (DP)
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Nomination
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Transfer and conversion of securities
          </a>
          <br />
        </div>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className="text-muted" style={{ fontSize: "18px" }}>
            <i class="fa-solid fa-credit-card"></i> Kite
          </h4>
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            IPO
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Trading FAQs
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Margin Trading Facility (MTF) and Margins
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Charts and orders
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Alerts and Nudges
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            General
          </a>
          <br />
        </div>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className="text-muted" style={{ fontSize: "18px" }}>
            <i class="fa-solid fa-credit-card"></i> Funds
          </h4>
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Add money
          </a>
          <br />
          <a href="" style={{fontSize:"14px", textDecoration: "none", lineHeight: "2.5" }}>
            Withdraw money
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            eMandates
          </a>
          <br />
        </div>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className="text-muted" style={{ fontSize: "18px" }}>
            <i class="fa-solid fa-circle-notch"></i> Console
          </h4>
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Portfolio
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Corporate actions
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Funds statement
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Reports
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Profile
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Segments
          </a>
          <br />
        </div>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className="text-muted" style={{ fontSize: "18px" }}>
            <i class="fa-solid fa-coins"></i> Coin
          </h4>
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Understanding mutual funds and Coin
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Coin app
          </a>
          <br />
          <a href="" style={{fontSize:"14px", textDecoration: "none", lineHeight: "2.5" }}>
            Coin web
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            Transactions and reports
          </a>
          <br />
          <a href="" style={{ fontSize:"14px",textDecoration: "none", lineHeight: "2.5" }}>
            National Pension Scheme (NPS)
          </a>
          <br />
        </div>
      </div>
    </div>
  );
}

export default CreateTicket;
